<app-org-appbar></app-org-appbar>
<br />

<kendo-tilelayout
  [columns]="1"
  [rowHeight]="'auto'"
>
  <kendo-tilelayout-item
    title="Feature Flags"
    [colSpan]="1"
  >
    <kendo-tilelayout-item-body>
      <p class="text-muted mb-4">Enable or disable features for this organization.</p>

      <form
        [formGroup]="flagsForm"
        novalidate
        (ngSubmit)="save()"
      >
        @for (flag of flagDefinitions; track flag.key) {
          <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
            <div>
              <strong>{{ flag.label }}</strong>
              <br />
              <small class="text-muted">{{ flag.description }}</small>
            </div>
            <kendo-switch [formControlName]="flag.key"></kendo-switch>
          </div>
        }

        <button
          kendoButton
          themeColor="primary"
          type="submit"
          class="mt-4"
          [disabled]="!flagsForm.dirty"
        >
          Save Changes
        </button>
      </form>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
</kendo-tilelayout>
